import { render, staticRenderFns } from "./LayoutEditBudgetsTab.vue?vue&type=template&id=1d985146"
import script from "./LayoutEditBudgetsTab.vue?vue&type=script&lang=ts"
export * from "./LayoutEditBudgetsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports